module.exports = __webpack_public_path__ + "static/img/app-img.d297dbd6.png";